import { render, staticRenderFns } from "./MarketplacePage.vue?vue&type=template&id=1265bf59&scoped=true"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePage.vue?vue&type=style&index=0&id=1265bf59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265bf59",
  null
  
)

export default component.exports